import { nFormatter } from "utils/parseNumber";
import { ReactComponent as ProfileIcon } from "components/icons/profile_gray.svg";
import { CheckButton } from "components/buttons/CheckButton";
import classes from "./UploadNicheItem.module.scss";
import { ReactNode } from "react";

interface IProps {
  img: string | null;
  name: string;
  subscribers: number;
  isSelected: boolean;
  index: number;
  id: string;
  disabled: boolean;
  select: (id: string) => void;
  profile_icon?: ReactNode;
  selected_icon?: string;
}

const UploadNicheItem = (props: IProps) => {
  const {
    img,
    name,
    subscribers,
    id,
    select,
    isSelected,
    index,
    disabled,
  } = props;

  return (
    <div className={classes.Container}
      style={{
        borderLeft: index % 2 !== 0 ? "1px solid rgba(255,255,255, 0.14)" : "none",
        paddingRight: index % 2 === 0 ? "1rem" : "0",
        paddingLeft: index % 2 === 0 ? "0" : "1rem",
      }}
    >
      <div className={classes.Info}>
        { img && <img className={classes.InfoImage} src={img} alt="" width="40" height="40"/>}
        <div className={classes.InfoContent}>
          <p className={classes.InfoContentName}>{name}</p>
          <div className={classes.InfoContentSubscribers}>
            <ProfileIcon/>
            <span>{nFormatter(subscribers)}</span>
          </div>
        </div>
      </div>
      <CheckButton onClick={() => select(id)} checked={isSelected} disabled={disabled} />
    </div>
  );
};

export default UploadNicheItem;
